import { Component } from '@theme/component';

/**
 * A custom element that renders a video background.
 *
 * @typedef {object} Refs
 * @property {HTMLElement[]} videoSources - The video sources.
 * @property {HTMLVideoElement} videoElement - The video element.
 *
 * @extends Component<Refs>
 */
export class VideoBackgroundComponent extends Component {
  requiredRefs = ['videoSources', 'videoElement'];

  get videoElements() {
    return Array.isArray(this.refs.videoElement) ? this.refs.videoElement : [this.refs.videoElement];
  }

  get allVideoSources() {
    return Array.isArray(this.refs.videoSources) ? this.refs.videoSources : [this.refs.videoSources];
  }

  connectedCallback() {
    super.connectedCallback();

    const videoSources = this.allVideoSources;
    const videoElements = this.videoElements;

    for (const source of videoSources) {
      const { videoSource } = source.dataset;

      if (videoSource) source.setAttribute('src', videoSource);
    }

    videoElements.forEach((video) => {
      if (video) video.load();
    });

    if (this.hasAttribute('data-sound-toggle-container')) {
      this.addEventListener('click', this.toggleSound.bind(this));
    }
  }

  toggleSound() {
    const videoElements = this.videoElements;
    if (!videoElements.length) return;

    const firstVideo = videoElements[0];
    const isMuted = !firstVideo.muted;

    videoElements.forEach((video) => {
      video.muted = isMuted;
    });

    if (isMuted) {
      this.classList.remove('is-playing');
    } else {
      this.classList.add('is-playing');
    }
  }
}

if (!customElements.get('video-background-component')) {
  customElements.define('video-background-component', VideoBackgroundComponent);
}
